module.exports = __webpack_public_path__ + "img/office_space.5e89ab26.jpg";